import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnMP: CultureInfo = {
  name: 'en-MP',
  displayName: 'English (Northern Mariana Islands)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-MP',
  parent: CultureInfoEn
};
